import createVueComponent from '../createVueComponent';

const StopCircle = createVueComponent('StopCircleIcon', [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['rect', { x: '9', y: '9', width: '6', height: '6' }],
]);

export default StopCircle;
